// Regras puras da tela de Tags (mockup "Tela Aeros Dark - Tags e Modais").
import { tagChip } from "../Contacts/contactRules";
import { i18n } from "../../translate/i18n";

export { tagChip };

export const FILTERS = ["all", "kanban", "unused"];

// Paleta do mockup (10 cores) + conta-gotas para cor livre.
export const SWATCHES = [
  "#A044FF", "#22D3EE", "#34D399", "#FBBF24", "#F87171",
  "#7DD3FC", "#F472B6", "#FB923C", "#A3E635", "#9CA3B8",
];

export const isHex = (v) => /^#[0-9a-f]{6}$/i.test(String(v || "").trim());
export const normalizeHex = (v) => {
  const s = String(v || "").trim().replace(/^#?/, "#");
  return isHex(s) ? s.toUpperCase() : null;
};

// Subtítulo "Etiquetas de contatos e tickets · K usadas no Kanban".
export const kanbanCount = (tags) => (tags || []).filter((t) => Number(t.kanban) === 1).length;

// timeLane é gravado em minutos; o modal mostra valor + unidade.
const t = (k, o) => i18n.t(`aeros.tags.${k}`, o);
export const TIME_UNITS = [
  { id: "minutes", factor: 1, get label() { return t("minutes"); } },
  { id: "hours", factor: 60, get label() { return t("hours"); } },
  { id: "days", factor: 1440, get label() { return t("days"); } },
];

export const minutesToUnit = (minutes) => {
  const m = Number(minutes) || 0;
  if (m <= 0) return { value: "", unit: "hours" };
  if (m % 1440 === 0) return { value: m / 1440, unit: "days" };
  if (m % 60 === 0) return { value: m / 60, unit: "hours" };
  return { value: m, unit: "minutes" };
};

export const unitToMinutes = (value, unit) => {
  const n = Number(value);
  if (!n || n <= 0) return 0;
  const f = TIME_UNITS.find((u) => u.id === unit)?.factor || 1;
  return Math.round(n * f);
};

// Recorrência: dias até reaplicar a tag a quem a perdeu.
export const RECURRENCE_OPTIONS = [
  { days: 0, get label() { return t("never"); } },
  { days: 7, get label() { return t("weekly"); } },
  { days: 15, get label() { return t("biweekly"); } },
  { days: 30, get label() { return t("monthly"); } },
  { days: 90, get label() { return t("quarterly"); } },
];

export const recurrenceLabel = (days) => {
  const n = Number(days) || 0;
  if (!n) return "";
  const opt = RECURRENCE_OPTIONS.find((o) => o.days === n);
  return opt ? opt.label : `A cada ${n} dias`;
};

// "há 2 dias" / "há 3 sem" para a lista de contatos da tag.
export const sinceLabel = (date, now = new Date()) => {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  const dias = Math.floor((now.getTime() - d.getTime()) / 86400000);
  if (dias <= 0) return t("agoToday");
  if (dias === 1) return t("agoDay");
  if (dias < 7) return t("agoDays", { n: dias });
  if (dias < 30) return t("agoWeeks", { n: Math.floor(dias / 7) });
  if (dias < 365) return Math.floor(dias / 30) === 1 ? t("agoMonth") : t("agoMonths", { n: Math.floor(dias / 30) });
  return t("agoYears", { n: Math.floor(dias / 365) });
};

// Linha exportada do modal "Contatos da tag".
export const tagContactRow = (c) => ({
  name: c.name,
  number: c.number,
  desde: c.taggedAt ? new Date(c.taggedAt).toLocaleDateString("pt-BR") : "",
});
